import { defineAsyncComponent } from 'vue'
import type { Component } from 'vue'

type DialogModule = { default: Component };
type DialogLoader = () => Promise<DialogModule>;
type ViteImportMeta = ImportMeta & {
  glob: <T>(pattern: string) => Record<string, () => Promise<T>>
};

const dialogComponents = (import.meta as ViteImportMeta).glob<DialogModule>('../../../dialogs/*.vue');

export function getDialogComponent(dialogName: string): Component | null {
  const loader = dialogComponents[`../../../dialogs/${dialogName}.vue`] as DialogLoader | undefined;
  if (!loader) {
    return null;
  }
  return defineAsyncComponent(loader);
}